import Repository from './Repository';

import { vue } from '../main';

const baseUrl = process.env.VUE_APP_API_URL;
const base = `${baseUrl}/channel/settings`;

export default {
  /**
   * Fetches a list of Channel Settings
   *
   * @returns {Promise<T | never>}
   */
  fetchSettings() {
    return Repository.get(`${base}/list`).then((res) => {
      // Push the settings in the store.
      vue.$store.commit('setChannelSettings', res.data.settings);

      return Promise.resolve(res);
    }).catch(err => Promise.reject(err));
  },
  /**
   * Resets all settings to their default.
   *
   * @returns {Promise<T | never>}
   */
  resetSettings() {
    return Repository.get(`${base}/reset`);
  },
  /**
   * Resets all settings to their default.
   *
   * @returns {Promise<T | never>}
   */
  saveSettings(payload) {
    return Repository.post(`${base}/save`, payload);
  },

  /**
   * Returns the default Channel Settings used to publish videos
   *
   * @returns {Promise<AxiosResponse<any>>}
   */
  getImportDefaults() {
    return Repository.get(`${base}/importdefaults`);
  },
};
